import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { FormWrapper } from 'components/Modal/styles';
import { Form } from 'components';
import ModalForm from 'components/ModalForm/ModalForm';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';
import { useCreateColor, useUpdateColor } from 'api/products/hooks';
import validationSchemas from './schemas';

const ColorForm = ({ type = 'create', initialValues, FormGroup }) => {
  const { t } = useTranslation(['pages', 'app']);
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { mutate: createColor, isPending: isCreating } = useCreateColor();
  const { mutate: updateColor, isPending: isUpdating } = useUpdateColor();
  return (
    <ModalForm
      initialValues={{
        uid: initialValues?.uid || undefined,
        name: initialValues?.name || '',
        hex_value: initialValues?.hex_value || '#000000',
      }}
      onSubmit={({ uid, name, hex_value }) =>
        type === 'update'
          ? updateColor({ uid, name, hex_value, region_uid: selectedRegion })
          : createColor({ name, hex_value, region_uid: selectedRegion })
      }
      validationSchema={validationSchemas.color}
      cancelLabel={t('app:cancel')}
      submitLabel={t(`app:${type}`)}
      pristine
      isLoading={isCreating || isUpdating}
      ignoreClickedState
      isClosePopupOn={false}
    >
      <FormWrapper style={{ minHeight: type === 'create' ? '400px' : 'unset' }}>
        <FormGroup required label={t('app:name')}>
          <Form.Input type="text" name="name" />
        </FormGroup>
        <FormGroup required label={t('pages:colors.hex')}>
          <Form.ColorPicker name="hex_value" />
        </FormGroup>
      </FormWrapper>
    </ModalForm>
  );
};

ColorForm.propTypes = {
  type: PropTypes.oneOf(['create', 'update']),
  initialValues: PropTypes.object,
  FormGroup: PropTypes.func,
};

export default ColorForm;
